<div *ngIf="!!commodityShippedList && commodityShippedList.length > 0; else noData">
    <mat-toolbar class="sticky-top mat-elevation-z6">
        <mat-toolbar-row *ngIf="count === 1">
            <span>
                <fa-icon [icon]="iconTrain" [fixedWidth]="true" size="lg"></fa-icon>
                {{ commodityShippedList[0]?.carInit }} {{ commodityShippedList[0]?.carNo }}
                <span class="small">{{
                    commodityShippedList[0]?.sightingDateTime | date : 'yyyy-MM-dd' : 'UTC'
                }}</span>
            </span>
            <span class="fill-remaining-space"></span>
            <span>
                <button mat-button (click)="currentTrip()" [disabled]="count !== 1">
                    <fa-icon [icon]="iconTrain" [fixedWidth]="true" size="lg"></fa-icon> View
                    Current Trip
                </button>
            </span>
        </mat-toolbar-row>
    </mat-toolbar>
    <section>
        <div class="container" style="margin-top: 20px">
            <div *ngFor="let compart of commodityShipped" class="row">
                <div class="col-sm-12">
                    <trip-commodity-shipped [commodityShipped]="compart" [showCommFac]="false">
                    </trip-commodity-shipped>
                    <rt-bds-commodity-display
                        [commodityCode]="compart.commodityCode"
                        [allowEdit]="true"
                        [editLink]="'/commodities'"
                    >
                    </rt-bds-commodity-display>
                </div>
            </div>
        </div>
    </section>
</div>

<ng-template #noData>
    <div style="padding: 20px; text-align: center; color: #999">
        No commodity shipped data selected
    </div>
</ng-template>
